import React, { ReactNode, useState } from 'react';
import styles from '../../styles.module.css';

export default function FilterBlock({ children, title }: { children?: ReactNode; title?: string }) {
  const [openAttributes, setOpenAttributes] = useState<Record<string, boolean>>({});
  const toggleAttribute = (slug?: string) => {
    if (!slug) return;

    setOpenAttributes((prev) => ({
      ...prev,
      [slug]: !prev[slug],
    }));
  };
  return (
    <div className={`${styles.filter_block}`}>
      <div className={`${styles.filter_label}`}>{title}</div>
      {/* <div className={styles.attributeTitle} onClick={() => toggleAttribute(title)}>
        <span className={`${styles.filter_label}`}>{title}</span>
        <span>{openAttributes[title] ? '−' : '+'}</span>
      </div> */}
      {/* {openAttributes[title] && children} */}
      {children}
    </div>
  );
}
